import { Component } from "react";

import { inject, observer } from "mobx-react";

import styled from "styled-components/macro";
import WorkflowView from "../components/WorkflowGraphView/WorkflowView";

import { AppStore } from "../../../stores/AppStore";


const Wrapper = styled.div`
  height: calc(100vh - 180px);
  border: 1px solid lightgrey;
`;


interface WorkflowListTabProps {}

interface InjectedProps extends WorkflowListTabProps {
  appStore: AppStore;
}

@inject("appStore")
@observer
class WorkflowListTab extends Component<WorkflowListTabProps> {

  get injected() { return this.props as InjectedProps; }
  get userStore() { return this.injected.appStore.userStore; }
  get trelloStore() { return this.injected.appStore.trelloStore; }

  render() {
    return (
      <Wrapper>
        <WorkflowView viewType="list" />
      </Wrapper>
    )
  }
}

export default WorkflowListTab;